"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var AuthenticationCard_1 = __importDefault(require("@/Jetstream/AuthenticationCard"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var Checkbox_1 = __importDefault(require("@/Jetstream/Checkbox"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ValidationErrors_1 = __importDefault(require("@/Jetstream/ValidationErrors"));
function Login(_a) {
    var canResetPassword = _a.canResetPassword, status = _a.status;
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({
        email: '',
        password: '',
        remember: '',
    });
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('login'), {
            onFinish: function () { return form.reset('password'); },
        });
    }
    return (react_1.default.createElement(AuthenticationCard_1.default, null,
        react_1.default.createElement(inertia_react_1.Head, { title: "login" }),
        react_1.default.createElement(ValidationErrors_1.default, { className: "mb-4" }),
        status && (react_1.default.createElement("div", { className: "mb-4 font-medium text-sm text-green-600" }, status)),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.default, { htmlFor: "email" }, "Email"),
                react_1.default.createElement(Input_1.default, { id: "email", type: "email", className: "mt-1 block w-full", value: form.data.email, onChange: function (e) { return form.setData('email', e.currentTarget.value); }, required: true, autoFocus: true })),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "password" }, "Password"),
                react_1.default.createElement(Input_1.default, { id: "password", type: "password", className: "mt-1 block w-full", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); }, required: true, autoComplete: "current-password" })),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement("label", { className: "flex items-center" },
                    react_1.default.createElement(Checkbox_1.default, { name: "remember", checked: form.data.remember === 'on', onChange: function (e) {
                            return form.setData('remember', e.currentTarget.checked ? 'on' : '');
                        } }),
                    react_1.default.createElement("span", { className: "ml-2 text-sm text-gray-600" }, "Remember me"))),
            react_1.default.createElement("div", { className: "flex flex-col space-y-2 md:flex-row md:items-center md:justify-between md:space-y-0 mt-4" },
                canResetPassword && (react_1.default.createElement("div", null,
                    react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('password.request'), className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Forgot your password?"))),
                react_1.default.createElement("div", { className: "flex items-center justify-end" },
                    react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('register'), className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Need an account?"),
                    react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)('ml-4', { 'opacity-25': form.processing }), disabled: form.processing }, "Log in"))))));
}
exports.default = Login;
